/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSend/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSend({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSend",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#653CAD"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSend.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Jl6r': alignSelf,'--mt-2-Jl6r': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Jl6r': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Jl6r': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Jl6r': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Jl6r': opacity,'--w-10-Jl6r': typeof width === 'number' ? `${width}px` : width,'--h-11-Jl6r': typeof height === 'number' ? `${height}px` : height,'--f-12-Jl6r': fill,'--a-7-Jl6r': isAnimated ? animation : "none",'--sd-8-Jl6r': isAnimated ? strokeDashoffset : 0,'--sd-9-Jl6r': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconSend.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M17.812.188c.18.18.236.449.145.686L11.53 17.588a.643.643 0 01-1.186.035L7.655 11.71l3.955-3.956a.964.964 0 10-1.363-1.363L6.29 10.345.377 7.657A.643.643 0 01.412 6.47L17.126.043a.643.643 0 01.686.145z"
 style={{'--f-12-Jl6r': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}